exports = module.exports = require("../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".label-container {\n  display: block; }\n\n.button-label-container {\n  display: inline; }\n\n.label-text,\n.label-icon {\n  display: inline-block;\n  vertical-align: middle; }\n\n.label-text {\n  letter-spacing: 0.3px;\n  font-weight: 400; }\n\n.label-icon > svg {\n  margin-right: 0px !important; }\n\n.label-container .label-text {\n  width: 100%;\n  word-break: break-word;\n  word-wrap: break-word;\n  white-space: nowrap;\n  -o-text-overflow: ellipsis;\n     text-overflow: ellipsis;\n  overflow: hidden; }\n\n@media only screen and (max-width: 768px) {\n  .label-container .label-text {\n    -o-text-overflow: ellipsis;\n       text-overflow: ellipsis;\n    overflow: auto; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Label/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/components/Label/index.css
// module chunks = 504